import { MODEL } from "../data";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="px-6 lg:px-12 pt-16 pb-10 border-t border-border">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
        <a
          href="#top"
          className="font-serif text-[16vw] lg:text-[10vw] leading-none font-light uppercase tracking-tighter text-foreground hover:text-accent transition-colors"
        >
          {MODEL.firstName} {MODEL.lastName}
        </a>
        <div className="text-right shrink-0">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
            {MODEL.location}
          </p>
          <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
            © {new Date().getFullYear()} — All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
